module.exports = __webpack_public_path__ + "img/delivery.7682df72.svg";